import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";

import { UserActionsHistoryFooterPaginationStyled } from "./user-actions-history-drawer.styled";

export type UserActionsHistoryDrawerFooterProps = {
  totalCards: number;
  pageCount: number;
  page: number;
  setPage: (page: number) => void;
  onClear: () => void;
};

export const UserActionsHistoryDrawerFooter: FC<
  UserActionsHistoryDrawerFooterProps
> = ({ totalCards, pageCount, page, setPage, onClear }) => {
  const { t } = useTranslation();
  return (
    <footer className="UserActionsHistory-Footer">
      <div className="UserActionsHistory-FooterLeading">
        {totalCards > 0 && pageCount > 1 && (
          <UserActionsHistoryFooterPaginationStyled
            count={pageCount}
            page={page}
            size="small"
            onChange={(_e, p) => setPage(p)}
            aria-label={t("userActionsHistory.paginationAriaLabel", {
              defaultValue: "History pages",
            })}
          />
        )}
      </div>
      <MuiButton
        className="UserActionsHistory-ClearButton"
        muiVariant="text"
        onClick={onClear}
        aria-label={t("userActionsHistory.clearAriaLabel", {
          defaultValue: "Clear history",
        })}
      >
        {t("userActionsHistory.clear")}
      </MuiButton>
    </footer>
  );
};
